export default {
  en: {
    orderFrom: 'Order from {name}',
    detailTitle: 'Order',
    deliveredAt: 'Will be delivered at {time}',
    courier: 'Courier',
    restaurantAddress: 'Restaurant address',
    deliveryAddress: 'Delivery address',
    itemsTitle: 'Order items',
    paymentTitle: 'Payment',
    payToCourier: 'Pay the courier on delivery',
    lineCount: 'Items',
    goodsTotal: 'Subtotal',
    totalDue: 'Total',
    itemQuantity: '{count} pcs',
    itemWeightWithQuantity: '{weight} × {count}',
    notFound: 'Order not found',
    mapAriaLabel: 'Order delivery map',
    errorLoadOrder: 'Failed to load order',
    errorLoadOrders: 'Failed to load order history',
    loadMore: 'Load more',
    deliveredAtLabel: '{date} at {time}',
    status: {
      paymentPending: 'Waiting for payment',
      new: 'Order placed',
      preparing: 'Order is being prepared',
      readyForPickup: 'Ready for pickup',
      courierAssigned: 'Courier assigned',
      pickedUp: 'On the way to you',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
    },
  },
  ru: {
    orderFrom: 'Заказ из {name}',
    detailTitle: 'Заказ',
    deliveredAt: 'Будет доставлен в {time}',
    courier: 'Курьер',
    restaurantAddress: 'Адрес ресторана',
    deliveryAddress: 'Адрес доставки',
    itemsTitle: 'Состав заказа',
    paymentTitle: 'К оплате',
    payToCourier: 'Оплата курьеру при получении',
    lineCount: 'Итого позиций',
    goodsTotal: 'Стоимость товаров',
    totalDue: 'Итого к оплате',
    itemQuantity: '{count} шт',
    itemWeightWithQuantity: '{weight} × {count}',
    notFound: 'Заказ не найден',
    mapAriaLabel: 'Карта доставки заказа',
    errorLoadOrder: 'Не удалось загрузить заказ',
    errorLoadOrders: 'Не удалось загрузить историю заказов',
    loadMore: 'Загрузить ещё',
    deliveredAtLabel: '{date} в {time}',
    status: {
      paymentPending: 'Ожидаем оплату',
      new: 'Заказ оформлен',
      preparing: 'Заказ готовится',
      readyForPickup: 'Заказ готов',
      courierAssigned: 'Курьер назначен',
      pickedUp: 'Курьер в пути',
      delivered: 'Заказ доставлен',
      cancelled: 'Заказ отменён',
    },
  },
}
